// extracted by mini-css-extract-plugin
module.exports = {"tellMe":"styles_tellMe__1G-6o","text":"styles_text__25EEP"};